import { render, staticRenderFns } from "./RegisterCoProducer.vue?vue&type=template&id=6b1d0b6e&scoped=true&"
import script from "./RegisterCoProducer.vue?vue&type=script&lang=js&"
export * from "./RegisterCoProducer.vue?vue&type=script&lang=js&"
import style0 from "./RegisterCoProducer.vue?vue&type=style&index=0&id=6b1d0b6e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b1d0b6e",
  null
  
)

export default component.exports